<ng-container *ngIf="!isLoading; else loading">
  <img *ngIf="image; else noImage" [class]="imageClass" [src]='image' [class.border]="hasBorder" [style]="imageCss" />
</ng-container>

<ng-template #noImage>
  <p *ngIf="showNoImage">{{noImageDisplayText}}</p>
</ng-template>

<ng-template #loading>
  <mat-spinner [diameter]="20"></mat-spinner>
</ng-template>
